"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.snakeToCapitalized = void 0;

var _capitalize = _interopRequireDefault(require("lodash/capitalize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts an underscore_string to an Capitalized String
 * @param {string} key String to convert
 */
var snakeToCapitalized = function snakeToCapitalized(key) {
  return (0, _capitalize.default)(key.replace(/_/g, ' '));
};

exports.snakeToCapitalized = snakeToCapitalized;
//# sourceMappingURL=snake-to-capitalized.js.map